/**
 * モジュール読み込み
 */
import 'slick-carousel';
import 'jquery-match-height';
import './modules/parallax/parallax-background.min';
import './modules/smooth-scroll/smooth-scroll';
import { FixedMidashi } from './modules/fixed-midashi/fixed-midashi';
var Masonry = require('masonry-layout');
var imagesLoaded = require('imagesloaded');


//===================================================
// functions
//===================================================
(function($) {
  // masonryレイアウト
  window.create_masonry = function() {
    var min_width = 768;
    var wipad = 1000;
    imagesLoaded.makeJQueryPlugin($);

    var masonry_update_list1_event = function() {
      var $container = $('.c-list1--event');
      var $masonry = null;

      if (! $container[0]) {
        return;
      }

      if ($('html').width() < min_width) {
        try {
          $masonry.destroy();
        } catch (e) {}
      } else if ($('html').width() < wipad) {
        $container.imagesLoaded(function() {
          $masonry = new Masonry($container[0], {
            itemSelector: '.c-list1--event .c-list1__card',
            gutter:50,
            percentPosition: true,
            horizontalOrder: true
          });
          $masonry.layout();
          window.masonry_update_event = function($target) {
            $masonry.appended($target);
          };
          window.masonry_layout_event = function() {
            $masonry.layout();
          };
        });
      } else {
        $container.imagesLoaded(function() {
          $masonry = new Masonry($container[0], {
            itemSelector: '.c-list1--event .c-list1__card',
            gutter:55,
            percentPosition: true,
            horizontalOrder: true
          });
          $masonry.layout();
          window.masonry_update_event = function($target) {
            $masonry.appended($target);
          };
          window.masonry_layout_event = function() {
            $masonry.layout();
          };
        });
      }
    };

    var masonry_update_list1_guest = function() {
      var $container = $('.c-list1--guest');
      var $masonry = null;

      if (! $container[0]) {
        return;
      }

      if ($('html').width() < min_width) {
        try {
          $masonry.destroy();
        } catch (e) {}
      } else if ($('html').width() < wipad) {
        $container.imagesLoaded(function() {
          $masonry = new Masonry($container[0], {
            itemSelector: '.c-list1--guest .c-list1__card',
            gutter:50,
            percentPosition: true,
            horizontalOrder: true
          });
          $masonry.layout();
          window.masonry_update_guest = function($target) {
            $masonry.appended($target);
          };
          window.masonry_layout_guest = function() {
            $masonry.layout();
          };
        });
      } else {
        $container.imagesLoaded(function() {
          $masonry = new Masonry($container[0], {
            itemSelector: '.c-list1--guest .c-list1__card',
            gutter:55,
            percentPosition: true,
            horizontalOrder: true
          });
          $masonry.layout();
          window.masonry_update_guest = function($target) {
            $masonry.appended($target);
          };
          window.masonry_layout_guest = function() {
            $masonry.layout();
          };
        });
      }
    };

    masonry_update_list1_event();
    masonry_update_list1_guest();
  };

  // fixed-midashi実行
  $(document).ready(function() {
    $('.fn-tab__list a').on('click', function() {
      setTimeout(function() {
        FixedMidashi.create();
      }, 200);
    });
  });

  // トップ メインビジュアル
  $(document).ready(function() {
    var $visual = $('.c-mainvisual__visualWrap');
    var $visualImg = $('.c-mainvisual__visualImg');
    setInterval(function() {
      $visual.toggleClass('is-rotate');
      $visualImg.toggleClass('is-rotate');
    }, 3000);
  });

  $(document).ready(function() {
    // SP メニュー
    var state = false;
    var scrollpos;
    $('.c-menu1--sp').on('click', function() {
      $(this).toggleClass('is-active');
      $('.c-menu2').toggleClass('is-active');

      if (! state) {
        scrollpos = $(window).scrollTop();
        $('html').addClass('is-fixed');
        state = true;
      } else {
        $('html').removeClass('is-fixed');
        window.scrollTo( 0 , scrollpos );
        state = false;
      }
    });
    $('.c-menu2__inner').on('click', function() {
      $('.c-menu1--sp').removeClass('is-active');
      $('.c-menu2').removeClass('is-active');
      $('html').removeClass('is-fixed');
      window.scrollTo(0, scrollpos);
      state = false;
    });

    // ページの先頭へ / ヘッダー固定
    var $header = $('.c-headerPC');
    var $headerSP = $('.c-headerSP');
    var $scrollTop = $('.c-pageTop');
    var $footer = $('c-footer');
    $(window).on('scroll', function() {
      var $scroll = $(window).scrollTop();
      var $footerCheck = $scroll > ($(window).height() - $footer.height());
      if ($scroll >= 200) {
        $header.addClass('is-active');
        $headerSP.addClass('is-active');
        $scrollTop.addClass('is-active');

        if ($footerCheck) {
          $scrollTop.addClass('is-footer');
        } else {
          $scrollTop.removeClass('is-footer');
        }
      } else {
        $header.removeClass('is-active');
        $headerSP.removeClass('is-active');
        $scrollTop.removeClass('is-active');
      }
    });
    $scrollTop.click(function() {
      $('html, body').animate({scrollTop: 0}, 600);
      return false;
    });

    // スライド
    var $slickElement = $('.c-slide-map__list');
    $slickElement.slick({
      autoplay: false,
      dots: false,
      arrows: false,
      centerMode: true,
      adaptiveHeight: true,
      centerPadding: '0',
      customPaging : function(slider, i) {
        var thumb = $(slider.$slides[i]).data();
        return '<a>'+(i)+'</a>';
      },
      responsive: [{
        breakpoint: 500,
        settings: {
          dots: false,
          arrows: false,
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }]
    });
    var $status = $('.c-slide-map__pagination');
    $slickElement.on('load init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
      var i = (currentSlide ? currentSlide : 0) + 1;
      $status.text(i + '/' + slick.slideCount);
    });
    $('#prev').on('click', function() {
      $slickElement.slick('slickPrev');
    });
    $('#next').on('click', function() {
      $slickElement.slick('slickNext');
    });
  });

  // Click button show item
  $(window).on('load', function() {
    $('.c-btn1--staff').on('click', function() {
      $('.c-list3__card:nth-child(n+11)').show();
      $(this).hide();
    });
  });

  // Read more sponsor
  $(document).ready(function() {
    $('.c-btn1--sponsor').on('click', function() {
      $(this).css({display: 'none'});
      $('.u-waitOpen').css({display: 'block'});
    });
  });

  // Hover scaleX
  $(document).ready(function() {
    if ($(window).width() > 999 && ! $('html').hasClass('ipad')) {
      $('.u-reverse').hover(function() {
        $(this).find('.u-reverseToggle').toggleClass('is-hover');
      });
    } else {
      $('.u-reverse').find('.u-reverseToggle').addClass('is-hover');
    }
  });

  // Achorlink
  $(window).on('load', function() {
    if ($(window).width() < 767) {
      $('.c-menu2__link1 .c-menu2__link1List .c-menu2__link1Text').on('click', function() {
        $('html').removeClass('is-fixed');
        $('.c-menu2').removeClass('is-active');
        $('.c-menu1').removeClass('is-active');
      });
    }
  });

  // Set Height c-list3__info__role
  $(document).ready(function() {
    $('.c-list3__info__role').matchHeight();
  });

  // table-cell 高さ揃え
  $(document).ready(function() {
    function setTableCell() {
      var cellHeight = 0;
      $('.fn-table-cell').each(function(index, elem) {
        if($(elem).height() > cellHeight) {
          cellHeight = $(elem).height();
        }
      });

      $('.fn-table-cell').each(function(index, elem) {
        $(elem).css({'height': cellHeight + 36 + 'px'});
      });
    };
    setTableCell();
    $(window).resize(setTableCell);
  });
})(jQuery);


//===================================================
// google map
//===================================================
(function($) {
  var new_map = function($el, index) {
    var $markers = $el.find('.marker');
    var args = {
      zoom: 16,
      center: new google.maps.LatLng(0, 0),
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      disableDefaultUI: true,
      styles: [
        {
          "elementType": "geometry.fill",
          "stylers": [
            {
              "color": "#d4f3d4"
            }
          ]
        },
        {
          "elementType": "labels.icon",
          "stylers": [
            {
              "visibility": "off"
            }
          ]
        },
        {
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#000000"
            }
          ]
        },
        {
          "featureType": "administrative.land_parcel",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#757575"
            }
          ]
        },
        {
          "featureType": "poi",
          "stylers": [
            {
              "visibility": "simplified"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#b0eeb5"
            }
          ]
        },
        {
          "featureType": "poi",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#757575"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#8ae98e"
            }
          ]
        },
        {
          "featureType": "poi.park",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#757575"
            }
          ]
        },
        {
          "featureType": "road",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#ffffff"
            }
          ]
        },
        {
          "featureType": "road.arterial",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#000000"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#ffffff"
            }
          ]
        },
        {
          "featureType": "road.highway",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#757575"
            }
          ]
        },
        {
          "featureType": "transit.line",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#b7d4aa"
            }
          ]
        },
        {
          "featureType": "transit.station",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#b2edb1"
            }
          ]
        },
        {
          "featureType": "transit.station.rail",
          "stylers": [
            {
              "visibility": "simplified"
            },
            {
              "weight": 0.5
            }
          ]
        },
        {
          "featureType": "transit.station.rail",
          "elementType": "geometry",
          "stylers": [
            {
              "visibility": "simplified"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "geometry",
          "stylers": [
            {
              "color": "#a0e0eb"
            }
          ]
        },
        {
          "featureType": "water",
          "elementType": "labels.text.fill",
          "stylers": [
            {
              "color": "#9e9e9e"
            }
          ]
        }
      ]
    };

    var map = new google.maps.Map($el[0], args);
    map.markers = [];
    $markers.each(function() {
      add_marker($(this), map);
    });
    center_map(map, index);
    return map;
  };

  var add_marker = function($marker, map) {
    if( ($(window).width() >= 768 && $marker.hasClass('pc-only'))
    || ($(window).width() < 767 && $marker.hasClass('sp-only'))) {
      var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
      var scale = new google.maps.Size($marker.attr('width'),$marker.attr('height'));
      var iconMap = {
        url: $marker.attr('data-icon'),
        scaledSize: scale,
      }
      var marker = new google.maps.Marker({
        position: latlng,
        icon: iconMap,
        map: map,
        zIndex: 1
      });
      map.markers.push(marker);
      google.maps.event.addListener(marker, 'mouseover',function() {
        this.setOptions({'zIndex': 9999});
      });
      google.maps.event.addListener(marker, 'mouseout',function() {
        this.setOptions({'zIndex': 0});
      });

      if ($marker.html()) {
        var infowindow = new google.maps.InfoWindow({
          content: $marker.html()
        });
        google.maps.event.addListener(marker, 'click', function() {
          infowindow.open(map, marker);
        });
      }
    }
  };

  var center_map = function(map, index) {
    var bounds = new google.maps.LatLngBounds();
    var windowWidth = $(window).width();
    var windowSm = 767;
    $.each(map.markers, function(i, marker) {
      var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
      bounds.extend(latlng);
    });

    if (index == 0) {
      map.setCenter(bounds.getCenter());
      map.setZoom(17);
      if (windowWidth <= windowSm) {
        map.setZoom(15);
      }
    } else {
      if (windowWidth <= windowSm) {
        map.fitBounds(bounds, 80);
      } else {
        map.setCenter(bounds.getCenter());
      }
    }
  };

  // global var
  var map = null;

  $(document).ready(function() {
    $('#map1').each(function(index, element) {
      map = new_map($(this), index);
    });
  });
})(jQuery);
